module.exports = __webpack_public_path__ + "static/media/anello.c7fc5722.png";